import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=7600e4eb&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7600e4eb')) {
      api.createRecord('7600e4eb', component.options)
    } else {
      api.reload('7600e4eb', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=7600e4eb&", function () {
      api.rerender('7600e4eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2alYqh2EsGcF8/JS/comp/ImgFallback.vue"
export default component.exports